import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

// const plans = [
//     {
//     name: "Premium",
//     monthlyUSD: 14,
//     monthlyINR: 1200,
//     query: 600,
//     yearlyDiscount: 0.2,
//     description:
//       "Complete home tutor solution with advanced features – $14 or 1200 INR per student",
//     features: [
//       "Up to 600 inputs",
//       "Advanced AI tools",
//       "Advanced analytics",
//       "Priority support",
//       "Custom assessments",
//       "Grade book integration",
//       "Parent communication",
//       "Automated workflows",
//       "Personalize AI for custom learning paths",
//       "Gamify AI for engagement",
//       "Curriculum mapping tools",
//       "Assessment and grading tools",
//       "Advanced reporting",
//       "Multi-student management",
//       "Emotional AI and sentiment analysis",
//     ],
//     cta: "Subscribe Premium",
//     popular: true,
//   },
//   {
//     name: "Enterprise",
//     monthlyUSD: null,
//     monthlyINR: null,
//     yearlyDiscount: null,
//     description: "Custom solution for large home tutor organizations",
//     features: [
//       "Unlimited students",
//       "All AI tools and features",
//       "Custom integrations",
//       "Dedicated account manager",
//       "Priority support",
//       "Custom curriculum mapping",
//       "Advanced reporting & analytics",
//       "White-label options",
//       "Custom training sessions",
//       "Multi-family management",
//       "Co-op support",
//       "Custom billing options",
//       "API access",
//       "SSO integration",
//     ],
//     cta: "Contact Sales",
//   },
// ];

const plans = [
  {
    name: "Premium",
    monthlyUSD: 14,
    monthlyINR: 1200,
    query: 600,
    yearlyDiscount: 0.2,
    description: "Complete home tutor solution with advanced features – $14 or 1200 INR per student",
    features: ["f1","f2","f3","f4","f5","f6","f7","f8","f9","f10","f11","f12","f13","f14","f15"],
    cta: "Subscribe Premium",
    popular: true,
  },
  {
    name: "Enterprise",
    monthlyUSD: null,
    monthlyINR: null,
    description: "Custom solution for large home tutor organizations",
    features: ["e1","e2","e3","e4","e5","e6","e7","e8","e9","e10","e11","e12","e13","e14"],
    cta: "Contact Sales",
  },
];

const makeDirectPayment = async (amount, planName, days, navigate) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/user/order`,
      { amount }
    );

    if (!data.success) {
      toast.error("Failed to create Razorpay order");
      return;
    }

    const { id: order_id, amount: order_amount, currency } = data.data;

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: order_amount,
      currency,
      name: "PSTVue",
      description: "Direct Amount Payment",
      order_id,
      handler: async function (response) {
        const token = JSON.parse(localStorage.getItem("token"));

        try {
          const verifyRes = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/user/verify`,
            {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              plan: planName.toLowerCase(),
              days,
              amount,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (verifyRes.data.success) {
            toast.success("Payment verified successfully!");
            navigate("/dashboard");
          } else {
            toast.error("Payment verification failed!");
          }
        } catch (error) {
          console.error("Verification error:", error);
          toast.error("Payment verification failed due to server error.");
        }
      },
      modal: {
        ondismiss: function () {
          toast.error("Payment cancelled by user.");
        },
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (error) {
    console.error("err...", error);
    alert("Something went wrong while processing payment.");
  }
};

const UpgradePlan = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [selectedBilling, setSelectedBilling] = useState({});
  const navigate = useNavigate();

  const handleBillingChange = (planName, billingType) => {
    setSelectedBilling((prev) => ({ ...prev, [planName]: billingType }));
  };

  const handleCTAClick = (plan) => {
    if (plan.cta === "Contact Sales" || plan.cta === "Start Free") {
      setShowModal(true);
    } else {
      const billingType = selectedBilling[plan.name] || "monthly";
      const price =
        billingType === "monthly"
          ? plan.monthlyINR
          : plan.monthlyINR * 12 * (1 - plan.yearlyDiscount);
      const days = billingType === "monthly" ? 30 : 365;

      makeDirectPayment(Math.round(price), plan.name, days, navigate);
    }
  };

return (
  <div className="min-h-screen bg-[#00254D] text-white py-12 px-4">
    <div className="max-w-6xl mx-auto">
      <h2 className="text-4xl font-bold text-center mb-8">
        {t("upgradePlan.title")}
      </h2>

      <div className="grid md:grid-cols-2 gap-8">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="relative flex flex-col justify-between p-6 rounded-xl shadow-lg bg-[#003366]"
          >
            {plan.popular && (
              <span className="absolute top-4 right-4 bg-yellow-400 text-[#00254D] text-xs font-bold px-3 py-1 rounded-full">
                {t("upgradePlan.popular")}
              </span>
            )}

            <div>
              <h3 className="text-2xl font-semibold mb-2">{plan.name}</h3>

              {plan.monthlyINR && (
                <div className="mb-4">
                  <label className="mr-4">
                    <input
                      type="radio"
                      name={`billing-${index}`}
                      value="monthly"
                      checked={selectedBilling[plan.name] === "monthly"}
                      onChange={() => handleBillingChange(plan.name, "monthly")}
                    />{" "}
                    {t("upgradePlan.monthly")}
                  </label>
                  <label>
                    <input
                      type="radio"
                      name={`billing-${index}`}
                      value="yearly"
                      checked={selectedBilling[plan.name] === "yearly"}
                      onChange={() => handleBillingChange(plan.name, "yearly")}
                    />{" "}
                    {t("upgradePlan.yearly")}
                  </label>
                </div>
              )}

              {plan.monthlyINR && (
                <>
                  <p className="text-xl mb-1">
                    {t("upgradePlan.perMonth", { amount: plan.monthlyINR })}
                  </p>
                  <p className="text-lg mb-1">
                    {t("upgradePlan.dialogsPerDay", { dialogs: plan.query })}
                  </p>
                </>
              )}

              {plan.yearlyDiscount && (
                <>
                  <p className="text-sm font-bold text-yellow-400 mt-2 mb-1">
                    {t("upgradePlan.discount", {
                      percent: plan.yearlyDiscount * 100,
                    })}
                  </p>
                  <p className="text-lg mb-1 line-through">
                    {t("upgradePlan.yearPrice", {
                      amount: plan.monthlyINR * 12,
                    })}
                  </p>
                  <p className="text-xl font-bold mb-4">
                    {t("upgradePlan.yearPriceDiscounted", {
                      amount: Math.round(
                        plan.monthlyINR * 12 * (1 - plan.yearlyDiscount)
                      ),
                    })}
                  </p>
                </>
              )}

              <p className="mb-4">
                {t("upgradePlan.description", { text: plan.description })}
              </p>

              <ul className="mb-6 space-y-2">
{plan.features.map((featureKey, idx) => (
  <li key={idx} className="flex items-center">
    <span className="mr-2">✔️</span>
    {t(`upgradePlan.features.${featureKey}`)}
  </li>
))}

              </ul>
            </div>

            <button
              onClick={() => handleCTAClick(plan)}
              className="mt-auto px-4 py-2 rounded-lg font-bold bg-white text-[#00254D] hover:bg-gray-200 transition"
            >
              {plan.cta === "Contact Sales"
                ? t("upgradePlan.ctaContact")
                : t("upgradePlan.ctaSubscribe")}
            </button>
          </div>
        ))}
      </div>
    </div>

    {showModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white text-[#00254D] rounded-lg p-8 w-full max-w-md text-center relative">
          <button
            className="absolute top-2 right-4 text-2xl font-bold"
            onClick={() => setShowModal(false)}
          >
            &times;
          </button>
          <h3 className="text-2xl font-bold mb-4">
            {t("upgradePlan.modalTitle")}
          </h3>
          <p className="mb-2">{t("upgradePlan.modalText")}</p>
          <a
            href="mailto:sales@mnrtechnologies.com"
            className="font-semibold text-blue-600 underline"
          >
            {t("upgradePlan.modalEmail")}
          </a>
        </div>
      </div>
    )}
  </div>
);

};

export default UpgradePlan;
